<template>
    <v-container class="my-3">
        <v-row v-if="error">
            <v-row class="justify-center mb-3">
                <div class="text-center text-body-1 font-weight-medium text--primary">Something went wrong
                </div>
            </v-row>
        </v-row>
        <v-row v-else-if="event == null">
            <v-col>
                <Loading />
            </v-col>
        </v-row>
        <v-row v-else align="center" justify="center">
            <v-col cols="12" sm="8" md="4">
                <v-row class="justify-center mb-6">
                    <div class="text-center text-body-1 font-weight-medium text--primary">2 easy steps to join {{ event.name
                    }}
                    </div>
                </v-row>
                <v-card variant="tonal" class="tonal-card py-3 my-4">
                    <v-col>
                        <v-row class="justify-center">
                            <div class="number-circle align-self-center"><span
                                    class="number-circle-span text--primary font-weight-medium">1</span></div>
                        </v-row>
                        <div class="px-3">
                            <div class="text-center text-body-1 text-primary  py-2"><span class="text--primary">Download the
                                    Pappyon app from your App Store</span></div>
                            <a :href="appUrl" target="_blank" class="text-decoration-none ma-2 white--text">
                                <v-btn elevation="0" block color="primary" large class="text-body-1 mt-4">Go to app
                                    store</v-btn></a>

                        </div>
                    </v-col>
                </v-card>
                <v-card variant="tonal" class="tonal-card py-3 my-3">
                    <v-col>
                        <v-row class="justify-center">
                            <div class="number-circle align-self-center"><span
                                    class="number-circle-span text--primary font-weight-medium">2</span></div>
                        </v-row>
                        <div class="px-3">
                            <div class="text-center text-body-1 text-primary  py-2"><span class="text--primary">Once the app
                                    is downloaded, you can then join the event.</span></div>
                            <a :href="eventUrl" target="_blank"
                                class="text-decoration-none ma-2 white--text"><v-btn elevation="0" block color="primary"
                                    large class="text-body-1 mt-4">Join event</v-btn></a>

                        </div>
                    </v-col>
                </v-card>
            </v-col>
        </v-row>
</v-container>
</template>
<script>
//  <a :href="`${item.urlPrefix}${item.info}`" target="_blank" class="text-decoration-none ma-2">Join event</a>
// @ is an alias to /src
import Loading from "@/components/Loading";
import "firebase/firestore";
import Event from "@/models/Event";
import {getEventDoc} from "@/shared/firebase_utils";

export default {
    name: 'JoinEvent',
    components: {
        Loading
    },

    data() {
        return {
            eventId: '',
            event: null,
            error: false,
            appUrl: this.$appHostUrl + '/app',
            eventUrl: ''
        }
    },
    methods: {

    },
    async created() {
        console.log(this.$route.params.eventId);
        this.eventId = this.$route.params.eventId;
        const eventDoc = await getEventDoc(this.eventId);
        if (eventDoc != undefined) {
            this.event = Event.fromFireStore(eventDoc);
            this.eventUrl = this.event.dynamicLink
        } else {
            this.error = true
        }

    }
}
</script>
<style scoped>
.number-circle {
    position: relative;
    border-radius: 50%;
    width: 60px;
    height: 60px;
    padding: 8px;
    background: #fff;
    vertical-align: middle;
    text-align: center;
    font-size: 24px;
}

.number-circle-span {
    display: inline-block;
    position: absolute;
    top: 20%;
    left: 0;
    right: 0;
    vertical-align: middle;
}

.tonal-card {
    background-color: #F6F7FC;
}
</style>
